module.exports = __webpack_public_path__ + "static/media/full-screen.fc113484.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/reports/assets/toolbar/full-screen.svg
// module id = 294
// module chunks = 0